<template>
    <div>
                <!-- Form Modal -->
                <b-modal
            id="modal-season-form"
            ref="myModal"
            centered
            no-close-on-backdrop
            no-close-on-esc
            size="sm"
            @ok="submitBranch"
        >
            <!-- Custom Modal Header -->
            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <h5 v-if="branch.id === null">Register Branch</h5>
                <h5 v-if="branch.id !== null">Edit Branch Center</h5>

                <feather-icon class="ml-4 pr-0 cursor-pointer" icon="XIcon" size="16" @click="close()" />
            </template>

            <!-- Custom Modal Footer -->
            <template #modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="primary" @click="ok()" :disabled="saving">
                    <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
                    <span v-if="!saving">Save</span>
                    <span v-if="saving">Saving...</span>
                </b-button>
                <b-button size="sm" @click="cancel()" variant="outline-secondary">
                    Cancel
                </b-button>
            </template>

            <!-- Data Form in Modal Body -->
            <template #default="{ }">
                <validation-observer ref="dataForm" #default="{ invalid }">
                    <b-form ref="form" @submit.stop.prevent="handleCreate">
                        <b-row>
                            <b-col cols="4">
                                <b-form-group label-for="branch_code" label="Bank">
                                    <validation-provider #default="{ errors }" name="bank_id" rules="">
                                        <b-form-select
                                            id="branch_code"
                                            name="branch_code"
                                            size="sm"
                                            v-model="branch.bank_id"
                                        >
                                            <b-form-select-option :value="null">Select...</b-form-select-option>
                                            <b-form-select-option :value="branch.bank_id" v-if="bank.id">{{ bank.abbreviation }}</b-form-select-option>
                                        </b-form-select>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col cols="8">
                                <b-form-group label-for="bank_id" label="Bank Name">
                                    <validation-provider #default="{ errors }" name="bank_id" rules="">
                                        <b-form-select
                                            id="bank_id"
                                            name="bank_id"
                                            size="sm"
                                            v-model="branch.bank_id"
                                        >
                                            <b-form-select-option :value="null">Select...</b-form-select-option>
                                            <b-form-select-option :value="bank.id" v-if="bank.id">{{ bank.name }}</b-form-select-option>
                                        </b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.bank_id">{{ serverErrors.bank_id[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="4">
                                <b-form-group label-for="code" label="CODE">
                                    <validation-provider #default="{ errors }" name="code" rules="">
                                        <b-form-input
                                            id="code"
                                            name="code"
                                            v-model="branch.code"
                                            :state="errors.length > 0 ? false : null"
                                            size="sm"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.code">{{ serverErrors.code[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="8">
                                <b-form-group label-for="name" label="Branch Name">
                                    <validation-provider #default="{ errors }" name="name" rules="">
                                        <b-form-input
                                            id="name"
                                            name="name"
                                            v-model="branch.name"
                                            :state="errors.length > 0 ? false : null"
                                            size="sm"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        <small class="text-danger" v-if="serverErrors && serverErrors.name">{{ serverErrors.name[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- Conveyor lins list -->
                        <b-row>
                            <b-col cols="12" md="12">
                                <location-filters
                                    size="sm"
                                    align="vertical"
                                    @filter="changeFilter"
                                />
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </template>
        </b-modal>
        <!-- ./Form Modal -->

        <!-- Form -->
        <b-card no-body>
            <b-card-body>
                <b-row>
                    <b-col cols="12">
                        <validation-observer ref="dataForm" #default="{ invalid }">
                            <b-form ref="form" @submit.stop.prevent="">
                                <b-row>
                                    <b-col cols="12" md="4">
                                        <b-row>
                                            <b-col cols="12">
                                                <b-form-group label-for="name" label="Bank Name">
                                                    <validation-provider #default="{ errors }" name="name" rules="">
                                                        <b-form-input
                                                            id="name"
                                                            name="name"
                                                            size="sm"
                                                            v-model="bank.name"
                                                            placeholder="Enter Bank Name"
                                                            :state="errors.length > 0 ? false : null"
                                                            auto-focus
                                                        />
                                                        <small class="text-danger" v-if="errors">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.name">{{ serverErrors.name[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="12" md="6">
                                                <b-form-group label-for="abbreviation" label="Abbreviation/Code">
                                                    <validation-provider #default="{ errors }" name="abbreviation" rules="">
                                                        <b-form-input
                                                            id="abbreviation"
                                                            name="abbreviation"
                                                            size="sm"
                                                            v-model="bank.abbreviation"
                                                            placeholder="Abbreviation"
                                                            :state="errors.length > 0 ? false : null"
                                                            auto-focus
                                                        />
                                                        <small class="text-danger" v-if="errors">{{ errors[0] }}</small>
                                                        <small class="text-danger" v-if="serverErrors && serverErrors.abbreviation">{{ serverErrors.abbreviation[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col cols="12" md="6">
                                                <b-button
                                                    size="sm"
                                                    variant="primary"
                                                    @click="submit"
                                                >
                                                    <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
                                                    <span v-if="!saving">Save</span>
                                                    <span v-if="saving">Saving...</span>
                                                </b-button>
                                            </b-col>
                                            <b-col cols="12" md="6">
                                                <b-button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    @click="resetForm"
                                                >
                                                    Reset
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    
                                    <b-col cols="12" md="8">
                                        <b-row>
                                            <b-col cols="6" md="6">
                                                <h6>Branches</h6>
                                            </b-col>
                                            <b-col cols="6" md="6" class="d-flex justify-content-end">
                                                <b-button variant="outline-primary" size="sm" @click="invokeCreateForm()">
                                                    <span class="text-nowrap">Add Branch</span>
                                                </b-button>
                                            </b-col>
                                        </b-row>

                                        <b-row class="mt-1">
                                            <b-col
                                                cols="12"
                                                md="12"
                                            >
                                                <b-table
                                                    :items="bank.branches"
                                                    :fields="branchesColumns"
                                                    small
                                                    responsive="sm"
                                                    sticky-header="300px"
                                                >
                                                    <template #cell(location)="data">
                                                        {{ data.item.location.name }} {{ data.item.location.level.name }}
                                                    </template>

                                                    <!-- Column: Actions -->
                                                    <template #cell(actions)="data">
                                                        <b-dropdown
                                                            variant="link"
                                                            no-caret
                                                            :right="$store.state.appConfig.isRTL"
                                                        >

                                                            <template #button-content>
                                                            <feather-icon
                                                                icon="MoreVerticalIcon"
                                                                size="16"
                                                                class="align-middle text-body"
                                                            />
                                                            </template>
                                            
                                                            <b-dropdown-item @click="invokeUpdateBranchForm(data.item)">
                                                                <feather-icon icon="EditIcon" />
                                                                <span class="align-middle ml-50">Edit</span>
                                                            </b-dropdown-item>
                                            
                                                            <b-dropdown-item @click="removeBranch(data.item.id)">
                                                                <feather-icon icon="TrashIcon" />
                                                                <span class="align-middle ml-50">Delete</span>
                                                            </b-dropdown-item>
                                                        </b-dropdown>
                                                    </template>
                                                </b-table>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </validation-observer>
                    </b-col>
                </b-row>
            </b-card-body>
            <!-- <b-card-body>{{ role }}</b-card-body> -->
        </b-card>
        <!-- ./Form -->

        <!-- Table Container Card -->
        <b-card no-body class="mb-0">
            <div class="m-2">
                <!-- Table Top -->
                <b-row>
                    <!-- Per Page -->
                    <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Show</label>
                        <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions" :clearable="false"
                            class="per-page-selector d-inline-block mx-50 select-size-sm" />
                        <label>entries</label>
                    </b-col>
                    <!-- ./Per Page -->

                    <!-- Search -->
                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                                size="sm"
                            />
                        </div>
                    </b-col>
                    <!-- ./Search -->
                </b-row>
                <!-- ./Table Top -->
            </div>

            <!-- Table -->
            <b-table
                striped
                hover
                small
                ref="records"
                class="position-relative"
                :items="fetch"
                responsive
                :fields="columns"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No records found"
                :sort-desc.sync="isSortDirDesc"
            >
                <!-- Column: Status -->
                <template #cell(branches)="data">
                    {{    data.item.branches.length.toLocaleString() }}
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">
                    <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                    >

                        <template #button-content>
                        <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="align-middle text-body"
                        />
                        </template>
        
                        <b-dropdown-item @click="invokeUpdateForm(data.item)">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Edit</span>
                        </b-dropdown-item>
        
                        <b-dropdown-item @click="remove(data.item.id)">
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Delete</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <!-- Table Footer -->
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRecords"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>

        </b-card>
        <!-- ./Table Container Card -->
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
    BCard, BCardHeader, BCardBody,
    BRow, BCol,
    BForm, BFormGroup, BFormInput, BFormCheckbox, BDropdown, BDropdownItem,
    BButton, BSpinner, BFormSelect, BFormSelectOption,
    BTable, BPagination, BBadge, BAvatar
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted, computed } from '@vue/composition-api'
import banksStoreModule from '@/views/cromis/payments/bank/banksStoreModule'
import useBanksList from '@/views/cromis/payments/bank/useBanksList'
import LocationFilters from '@core/components/cromis/filters/LocationFilters.vue'

export default {
    props: {},
    components: {
        BCard, BCardHeader, BCardBody,
        BRow, BCol,
        BForm, BFormGroup, BFormInput, BFormCheckbox, BDropdown, BDropdownItem, vSelect,
        BButton, BSpinner, BFormSelect, BFormSelectOption,
        BTable, BPagination, BBadge, BAvatar,
        ValidationProvider, ValidationObserver,
        LocationFilters,
    },
    directives: {},
    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)

        const branchesColumns = ref([
            { key: 'name', label: 'Branch Name', sortable: false, thStyle: { width: "35%" }, thClass: 'text-left', tdClass: 'text-left' },
            { key: 'code', sortable: false, thStyle: { width: "8%" }, thClass: 'text-left', tdClass: 'text-left' },
            { key: 'location', sortable: true, thStyle: { width: "37%" }, thClass: 'text-left', tdClass: 'text-left' },
            { key: 'accounts', sortable: false, thStyle: { width: "8%" }, thClass: 'text-right', tdClass: 'text-right' },
            'actions',
        ])

        const bank = ref({
            isBank: true,
            id: null,
            name: null,
            abbreviation: null,
            branches: [],
        })

        const branch = ref({
            isBank: false,
            id: null,
            name: null,
            code: null,
            bank_id: null,
            location_id: null,
        })

        const CROMIS_GROUP_STORE_MODULE_NAME = 'cromis-bank'

        // Register module
        if (!store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.registerModule(CROMIS_GROUP_STORE_MODULE_NAME, banksStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_GROUP_STORE_MODULE_NAME)
        })

        onMounted(async () => {
           
        })

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            myBanks,

            // UI
            // resolveUserRoleVariant,
            // resolveUserRoleIcon,
            resolveStatusVariant,
        } = useBanksList()

        // Form Methods
        const invokeUpdateForm = (item) => {
            bank.value = item
        }

        const invokeCreateForm = () => {
            branch.value.isBank = false
            branch.value.id = null
            branch.value.name = null
            branch.value.code = null
            branch.value.bank_id = bank.value.id
            branch.value.location_id = null

            myModal.value.show()
        }

        const invokeUpdateBranchForm = (item) => {
            branch.value.isBank = false
            branch.value.id = item.id
            branch.value.name = item.name
            branch.value.code = item.code
            branch.value.bank_id = bank.value.id
            branch.value.location_id = item.location.id

            myModal.value.show()
        }

        const changeFilter = (location) => {
            branch.value.location_id = location !== null? location.id : null
        }

        const resetForm = () => {
            bank.value = {
                isBank: true,
                id: null,
                name: null,
                abbreviation: null,
                branches: [],
            }
        }

        const isFormValid = async () => {
            let isValid = false 
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = (bvModalEvt) => {
            bvModalEvt.preventDefault()
            serverErrors.value = null

            // Handle form submit
            if (bank.value.id === null || bank.value.id === 0)
                handleCreate()
            else
                handleUpdate(bank.value)
        }

        const submitBranch = async (bvModalEvt) => {
            bvModalEvt.preventDefault()
            serverErrors.value = null

            // Handle form submit
            let bank_id = branch.value.bank_id
            if (branch.value.id === null || branch.value.id === 0){
                await store.dispatch('cromis-bank/createBranch', branch.value)
                            .then(response => {
                                refetch()
                                saving.value = false
                                bank.value.branches.push(response.data)

                                myModal.value.hide()
                            })
                            .catch(error => {
                                saving.value = false
                                if(error.response.status === 422){
                                    serverErrors.value = error.response.data.errors
                                }
                                else{
                                    context.root.$swal({
                                        icon: 'error',
                                        title: 'Server Error',
                                        text: 'Something went wrong. See tech support',
                                        showConfirmButton: true,
                                        customClass: {
                                            confirmButton: 'btn btn-danger',
                                        },
                                        buttonsStyling: false,
                                    })
                                }
                            })
            }
            else{
                await store.dispatch('cromis-bank/updateBranch', { id: branch.value.id, data: branch.value })
                            .then(response => {
                                saving.value = false

                                myModal.value.hide()
                            })
                            .catch(error => {
                                saving.value = false
                                if(error.response.status === 422){
                                    serverErrors.value = error.response.data.errors
                                }
                                else{
                                    context.root.$swal({
                                        icon: 'error',
                                        title: 'Server Error',
                                        text: 'Something went wrong. See tech support',
                                        showConfirmButton: true,
                                        customClass: {
                                            confirmButton: 'btn btn-danger',
                                        },
                                        buttonsStyling: false,
                                    })
                                }
                            })
            }

            await store.dispatch('cromis-bank/show', { id: bank_id })
                        .then(response => {
                            bank.value = response.data
                        })
                        .catch(error => {
                            console.log(error)
                            context.root.$swal({
                                icon: 'error',
                                title: 'Server Error',
                                text: 'Something went wrong. See tech support',
                                showConfirmButton: true,
                                customClass: {
                                    confirmButton: 'btn btn-danger',
                                },
                                buttonsStyling: false,
                            })
                        })
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if(!valid){
                saving.value = false
                return
            }

            await store.dispatch('cromis-bank/create', bank.value)
                .then(response => {
                    refetch()
                    saving.value = false
                    resetForm()

                    context.root.$swal({
                        icon: 'success',
                        text: `Bank ${response.data.name} has been registered successfully!`,
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    resetForm()
                    if(error.response.status === 422){
                        serverErrors.value = error.response.data.errors
                    }
                    else{
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async (item) => {
            saving.value = true
            const valid = await isFormValid()

            if(!valid){
                saving.value = false
                return
            }

            await store.dispatch('cromis-bank/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to bank ${response.data.title} has been made successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                    resetForm()
                })
                .catch(error => {
                    saving.value = false
                    resetForm()
                    console.log(error)
                    if(error.response.status === 422){
                        serverErrors.value = error.response.data.errors
                    }
                    else{
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const remove = async (id) => {
            await store.dispatch('cromis-bank/remove', id)
                        .then(response => {
                            refetch()
                        })
                        .catch(error => {
                            context.root.$swal({
                                icon: 'error',
                                title: 'Server Error',
                                text: 'Something went wrong. See tech support',
                                showConfirmButton: false,
                                customClass: {
                                    confirmButton: 'btn btn-danger',
                                },
                                buttonsStyling: false,
                            })
                        })
        }

        const removeBranch = async (id) => {
            let bank_id = bank.value.id
            await store.dispatch('cromis-bank/removeBranch', id).then(response => {
                        // TODO:: Nothing to do with a response
                    })
                    .catch(error => {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: false,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    })

            await store.dispatch('cromis-bank/show', { id: bank_id })
                        .then(response => {
                            bank.value = response.data
                        })
                        .catch(error => {
                            console.log(error)
                            context.root.$swal({
                                icon: 'error',
                                title: 'Server Error',
                                text: 'Something went wrong. See tech support',
                                showConfirmButton: true,
                                customClass: {
                                    confirmButton: 'btn btn-danger',
                                },
                                buttonsStyling: false,
                            })
                        })
        }
        
        return {
            // Form
            dataForm,
            saving,
            serverErrors,
            bank,
            branch,
            isFormValid,
            submit,
            submitBranch,
            handleCreate,
            invokeUpdateForm,
            invokeUpdateBranchForm,
            handleUpdate,
            remove,
            removeBranch,
            resetForm,

            // Validations
            required,

            // Table
            fetch,
            columns,
            branchesColumns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            resolveStatusVariant,
            invokeCreateForm,
            changeFilter,
            myModal,
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
